'use strict';

var FilmShader = require( './materials/FilmShader.js' );

module.exports = function(){

  var width = 256;
  var height = 128;

  var rt = new THREE.WebGLRenderTarget( width, height, {} );

  var scene = new THREE.Scene();

  var clock = new THREE.Clock();

  var mesh = new THREE.Mesh(
    new THREE.PlaneGeometry(2, 2),
    new FilmShader({
      side: 2
    }));

  mesh.scale.multiplyScalar( 500 );

  scene.add(mesh);

  return {
    
    texture: rt.texture,

    draw: function(renderer, camera){
      mesh.material.uniforms.time.value = clock.getElapsedTime();
      renderer.render(scene, camera, rt, true);
    }
  }
}